export const CHECKLISTS = `
	query checklists($event_id: Uint!) {
		checklists(event_id: $event_id) {
			id
			event_id
			name
			content
			version
		}
	}
`;

export const CHECKLIST_COUNTS = `
	query checklist($id: Uint!) {
		checklist(id: $id) {
			id
			completion_counts {
				item_id
				count
			}
		}
	}
`;
